(() => {
  'use strict';
  const root = document.documentElement;
  const preference = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  let saved = false;
  try { saved = localStorage.getItem('chillance-motion-paused') === 'true'; } catch (_) {}
  let paused = saved || preference.matches || Boolean(navigator.connection && navigator.connection.saveData);
  function syncMotion() {
    root.dataset.motion = paused || preference.matches ? 'paused' : 'active';
    document.querySelectorAll('[data-motion-toggle]').forEach(button => {
      button.hidden = preference.matches;
      button.setAttribute('aria-pressed', String(paused));
      const label = paused ? button.dataset.resumeLabel : button.dataset.pauseLabel;
      button.setAttribute('aria-label', label);
      button.title = label;
      const text = button.querySelector('[data-motion-label]');
      if (text) text.textContent = paused ? button.dataset.resumeShort : button.dataset.pauseShort;
    });
  }
  let observer;
  if ('IntersectionObserver' in window && !preference.matches) {
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px 40px 0px' });
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-spotlight]').forEach(stage => {
      if (stage.dataset.motionReady) return;
      stage.dataset.motionReady = 'true';
      const tabs = stage.querySelector('[data-spotlight-tabs]');
      if (tabs) tabs.hidden = false;
      stage.addEventListener('click', event => {
        const button = event.target.closest('[data-scene-target]');
        if (!button) return;
        stage.querySelectorAll('[data-scene]').forEach(scene => { scene.hidden = scene.dataset.scene !== button.dataset.sceneTarget; scene.classList.toggle('scene-switched', !scene.hidden); });
        stage.querySelectorAll('[data-scene-target]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        stage.dataset.currentScene = button.dataset.sceneTarget;
      });
    });
    if (observer) scope.querySelectorAll('[data-reveal]').forEach(element => {
      if (element.dataset.revealReady) return;
      element.dataset.revealReady = 'true';
      if (element.getBoundingClientRect().top < window.innerHeight) element.classList.add('is-revealed');
      else { element.classList.add('reveal-ready'); observer.observe(element); }
    });
    syncMotion();
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-motion-toggle]')) return;
    paused = !paused;
    try { localStorage.setItem('chillance-motion-paused', String(paused)); } catch (_) {}
    syncMotion();
  });
  document.addEventListener('visibilitychange', () => { root.dataset.pageHidden = String(document.hidden); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('chillance:content', () => init());
  if (preference.addEventListener) preference.addEventListener('change', syncMotion);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  window.ChillanceMotion = { init, transition(change) {
    if (document.startViewTransition && !paused && !preference.matches) return document.startViewTransition(change);
    change();
  } };
})();
